import { NgModule } from '@angular/core';
import { HolidayComponent } from './holiday.component';
import { moduleConfigFunc, TnxSharedModule } from 'tnx-shared';
import { HolidayRoutes } from './holiday.routing';
import { HolidayFormComponent } from './holiday-form/holiday-form.component';


export function declaration() {
  return [HolidayComponent, HolidayFormComponent];
}

@NgModule({
  imports: [
    TnxSharedModule
  ],
  declarations: declaration(),
  exports: declaration()
})
export class HolidayModule {
  static forRoot(config?: any): any {
    return {
      ngModule: TnxSharedModule,
      providers: [
        {
          provide: moduleConfigFunc,
          useValue: config
        }
      ]
    };
  }
}

@NgModule({
  imports: [HolidayModule, HolidayRoutes],
  exports: [HolidayModule]
})
export class HolidayWithRouteModule {
  static forRoot(config?: any): any {
    return {
      ngModule: TnxSharedModule,
      providers: [
        {
          provide: moduleConfigFunc,
          useValue: config
        }
      ]
    };
  }
}
